export default __webpack_public_path__ + "static/media/Facebook.49dd6333.svg";